import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {platformBrowser} from "@angular/platform-browser";
import {isPlatformBrowser} from "@angular/common";
import {LogService} from "./log.service";
import {NgcCookieConsentService} from "ngx-cookieconsent";

declare var gtag : any;
declare var fbq : any;

@Injectable({providedIn: 'root'})
export class AnalyticsService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private logService: LogService, public cookieContentService:NgcCookieConsentService) {}
  trackEvent(eventName: string, eventDetails: string, eventCategory: string) {
    if(isPlatformBrowser(this.platformId)){
      if(this.cookieContentService.hasConsented()) {
        gtag('event', eventName, {
          'event_category': eventCategory,
          'event_label': eventName,
          'value': eventDetails
        })
      }
    }
  }
  trackPageView(path:string, pageName: string) {
    if(isPlatformBrowser(this.platformId)){
      if(this.cookieContentService.hasConsented()) {
        this.logService.logTracker('trackPageView', path, pageName);
        gtag('event', 'page_view', {
          'path': path,
          'page_name': pageName
        });
        fbq('track', 'PageView');
      } else {
        this.logService.logNotTracker('trackPageView', path, pageName);
      }
    }
  }
}
